import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles, type Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import WidgetsIcon from '@material-ui/icons/Widgets';
import { colors } from '@skyslope/mache';
import { Pill } from '../common';
import { StyledMenu, StyledMenuItem } from '../common/StyledMenu';
import { STATUSES } from './utils';

interface IProps {
  statuses: string[];
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  selectedStatus: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: colors.grey[800],
    marginTop: '10px',
    '&:focus': {
      border: `1px solid ${colors.blue[100]}`,
    },
  },
  statusIcon: {
    color: colors.grey[500],
  },
  filterText: {
    marginRight: theme.spacing(1),
  },
  statusText: {
    margin: '0 5px',
  },
}));

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const FilterStatus = (props: IProps) => {
  const { statuses, statusFilter, setStatusFilter, selectedStatus } = props;
  const buttonRef = React.useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const classes = useStyles();
  // @ts-expect-error -- This code was written prior to enforcing lint rules
  const currentStatusFilter = STATUSES[statusFilter];
  const filtersToDisplay = statuses.filter((status: string) => status !== selectedStatus);

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const openMenu = (event: any) => {
    setIsMenuOpen(true);
    buttonRef.current = event.currentTarget;
  };

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const handleSetStatusFilter = (status: string) => {
    setIsMenuOpen(false);
    setStatusFilter(status);
  };

  return (
    <>
      <div className={classes.wrapper}>
        <Typography variant="body1" className={classes.filterText}>
          Filter results by:
        </Typography>
        <Button onClick={openMenu} aria-label="Status Filter">
          <WidgetsIcon className={classes.statusIcon} />
          <span className={classes.statusText}>Status</span>
          <ArrowDropDownIcon />
        </Button>
        <StyledMenu
          keepMounted
          anchorEl={buttonRef.current}
          open={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          {filtersToDisplay.map((status: string) => (
            <StyledMenuItem
              aria-label={`${status} filter`}
              // @ts-expect-error -- This code was written prior to enforcing lint rules
              data-spec={`filter-status-menu-item-${STATUSES[status].key}`}
              // @ts-expect-error -- This code was written prior to enforcing lint rules
              key={STATUSES[status].key}
              onClick={() => handleSetStatusFilter(status)}
            >
              {/* @ts-expect-error -- This code was written prior to enforcing lint rules */}
              {STATUSES[status].label}
            </StyledMenuItem>
          ))}
        </StyledMenu>
      </div>
      {statusFilter ? (
        <div className={classes.wrapper}>
          <Pill
            key={currentStatusFilter.key}
            id={currentStatusFilter.key}
            text={currentStatusFilter.label}
            onDelete={() => setStatusFilter('')}
            icon={<WidgetsIcon />}
            pillDetail="filter"
          />
        </div>
      ) : null}
    </>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default FilterStatus;
